const DEBOUNCE_MS = 2000;

let lastExpiredTimestamp = 0;

export const shouldDispatchSessionExpired = () => {
    return Date.now() - lastExpiredTimestamp > DEBOUNCE_MS;
};

export const markSessionExpired = () => {
    lastExpiredTimestamp = Date.now();
};
